import { axiosGu } from "config";

export const refreshToken = () => axiosGu.post("/auth/refresh");
